import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const fade = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.25;
  }
`;

export const SpinnerContainer = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => size || 24}px;
  height: ${({ size }) => size || 24}px;
  display: inline-block;
`;

export const Bar = styled.div`
  width: 10%;
  height: 25%;
  background: #fff;
  position: absolute;
  left: 49%;
  top: 36%;
  opacity: 0;
  border-radius: 50px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  animation: ${fade} 1s linear infinite;
`;
